<div class="root-container"
     [libLoadingOverlay]="appService.lockAppStream | async">
  <lib-app-header appName="User Management" [email]="user?.email" (menuClick)="toggleSideNav()"></lib-app-header>
  <div class="app-container flex-1 min-height-0">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
      <app-left-side-nav>
        <div class="app-content min-height-0">
          <router-outlet></router-outlet>
        </div>
      </app-left-side-nav>
    }
  </div>
  <lib-app-footer></lib-app-footer>
</div>

